import { Container } from "../../styles/signup";
import TextFieldView from "../../components/commons/TextField.view";
import { useEffect, useState } from "react";
import { AuthApi, AuthType } from "../../api/Auth.api";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { UserApi } from "../../api/User.api";
import { useAppDispatch } from "../../store";
import { setUser } from "../../store/modules/app";
import Error from "../../models/Error.model";
import { ERROR_TYPE, Product } from "../../commons/Const";
import { Storage } from "../../utils/Storage";
import OrderSubscriptionView from "../../components/OrderSubscription.view";
import moment from "moment";


export default function SignUpPage() {

  const navigate = useNavigate()
  const location = useLocation()

  const dispatch = useAppDispatch()

  const [isCertificate, setIsCertificate] = useState(false)
  const [type, setType] = useState<AuthType>('')
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')

  const [uid, setUid] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const [emailMessage, setEmailMessage] = useState('')
  const [passwordMessage, setPasswordMessage] = useState('')
  const [confirmPasswordMessage, setConfirmPasswordMessage] = useState('')

  const [agreeArray, setAgreeArray] = useState<boolean[]>([true, true, true, true])

  const [product, setProduct] = useState<Product|null>(null);
  const [payMethod, setPayMethod] = useState(0);

  useEffect(() => {

    if(!location.state) return

    const type = location.state.type
    const uid = location.state.uid

    if(type !== undefined) setType(type)    
    if(uid !== undefined) setUid(uid)

  }, [location])

  useEffect(() => {
    if(uid !== '') setEmailMessage('')
  }, [uid])

  useEffect(() => {
    if(password !== '') setPasswordMessage('')
  }, [password])

  useEffect(() => {
    if(confirmPassword === '') return

    if(password === confirmPassword) setConfirmPasswordMessage('')
    else setConfirmPasswordMessage('비밀번호가 일치하지 않습니다.')
  }, [password, confirmPassword])

  const certificate = () => {
    const { IMP } = window
      IMP.init('imp84428497');
      //IMP.init('imp10391932');
      

      /* 2. 본인인증 데이터 정의하기 */
      const data = {
        // merchant_uid: `mid_${new Date().getTime()}`,
        // company: '아임포트',
        // carrier: 'SKT',
        // name: '홍길동',
        // phone: '01012341234'
      };

      /* 4. 본인인증 창 호출하기 */
      IMP.certification(data, (response: any) => {
        const {
        success,
        merchant_uid,
        imp_uid,
        error_msg
      } = response;

      if (response.success) {
        checkCertificate(imp_uid)
        
      } else {
        alert(`본인인증 실패: ${error_msg}`);
      }
      });
  }

  const checkCertificate = (imp_uid: string) => {
    AuthApi.certification(imp_uid, 'signUp')
    .then(result => {
      setIsCertificate(true)
      setName(result.name)
      setPhone(result.phone)
    }).catch(error => {
      setIsCertificate(false)
      if(error instanceof Error) {
        if(error.code === ERROR_TYPE.EXIST_USER) {
          alert('해당 번호로 가입된 계정이 있습니다.')
        }
      }
    })
  }

  const signUp = async () => {

    if(!isCertificate) return alert('본인인증을 진행해주세요.');

    let isNext = true
    
    if(type === 'email') {
      //if(password === '') setPasswordMessage('비밀번호를 입력해주세요.')

      if(uid === '') {
        setEmailMessage('이메일을 입력해주세요.')
        isNext = false
      }
      if(password === '') {
        setPasswordMessage('비밀번호를 입력해주세요.')
        isNext = false
      }

      if(password !== confirmPassword) {
        setConfirmPasswordMessage('비밀번호가 일치하지 않습니다.')
        isNext = false
      }

      if(!isNext) return

    }

    if(product === null) return;

    let amount = product.price + product.vat;

    if(process.env.REACT_APP_IS_TEST === 'true') {
      
      if(product.id === 3) {
        amount = (amount / 1000);
      }
      else {
        amount = (amount / 100);
      }
    }

    let paymentData: any = {};

    if(payMethod === 0) {
      paymentData = {
        pg: process.env.REACT_APP_PG_CARD,
        pay_method : 'card',
        merchant_uid : `${phone}-${new Date().getTime()}`,
        name : product.name,
        amount : amount,
        buyer_name : name,
        buyer_tel : phone,
        customer_uid: `sellerguard${process.env.REACT_APP_MODE === 'stage' ? '-stage' : ''}-${phone}`,
        period : {
          from : moment().format('YYYYMMDD'), //YYYYMMDD
          to : moment().add(1, 'month').subtract(1, 'day').format('YYYYMMDD')
        }
      }
    }
    else if(payMethod === 1) {
      paymentData = {
        pg: process.env.REACT_APP_PG_PHONE,
        pay_method : 'phone',
        merchant_uid : `${phone}-${new Date().getTime()}`,
        name : product.name,
        amount : amount,
        buyer_name : name,
        buyer_tel : phone,
        customer_uid: `sellerguard-stage-${phone}`,
        period : {
          from : moment().format('YYYYMMDD'), //YYYYMMDD
          to : moment().add(1, 'month').subtract(1, 'day').format('YYYYMMDD')
        }
      }
    }

    try {

      await AuthApi.checkUid(uid);
      
      const paymentResult = await requestPayment(paymentData);

      const result = await AuthApi.signUp({
        type, name, phone, uid, password,
        productId: product.id,
        payMethod: payMethod,
        paymentData: paymentResult,
      });

      Storage.set('token', result.token);
      // navigate('/signup/success')
      getUser();
  
    } catch (error) {
      console.log(error)
      if(error instanceof Error) {
        if(error.code === ERROR_TYPE.EXIST_EMAIL) {
          alert('이미 존재하는 아이디입니다.');
          setEmailMessage('이미 존재하는 아이디입니다.')
        }
        else if(error.code === ERROR_TYPE.EXIST_PHONE) {
          alert('해당 번호로 가입된 계정이 있습니다.');
          alert('해당 번호로 가입된 계정이 있습니다.')
        }
      }
    }
  }

  const getUser = () => {
    UserApi.getMe()
    .then(result => {
      dispatch(setUser(result))
      //navigate('/subscription')
      navigate('/signup/success')
    }).catch(console.error)
  }

  const requestPayment = async (data: any): Promise<any> => {

    return new Promise((resolve, reject) => {
      const { IMP } = window
      IMP.init("imp84428497");

      IMP.request_pay(data, (response: any) => {
        if(response.success) {
          resolve(response);
        }
        else {
          reject(response);
        }
      });
    })
  }

  return (
    <Container className="singup">
      <div className="inner">
        <p className="page_title"><span>회원가입</span></p>

        <section>
          {!isCertificate && (
            <>
              <p className="form_label">본인인증</p>
              <button className="contained_light_green btn_certification"
                onClick={certificate}
              >인증하기</button>
            </>
          )}

          {isCertificate && (
            <>
              <p className="form_label">이름</p>
              <p className="name">{name}</p>

              <p className="form_label">연락처</p>
              <p className="tel">{phone}</p>
            </>
          )}

          {type === 'email' && (
            <>
              <TextFieldView
                value={uid}
                onChange={setUid}
                title="아이디"
                type="text"
                placeholder="아이디"
                errorMessage={emailMessage}
                styles={{
                  marginBottom: 36
                }}
              />

              <TextFieldView
                value={password}
                onChange={setPassword}
                title="비밀번호"
                type="password"
                placeholder="비밀번호"
                errorMessage={passwordMessage}
                styles={{
                  marginBottom: 36
                }}
              />

              <TextFieldView
                value={confirmPassword}
                onChange={setConfirmPassword}
                title="비밀번호 확인"
                type="password"
                placeholder="비밀번호 확인"
                errorMessage={confirmPasswordMessage}
              />
            </>
          )}

          <OrderSubscriptionView 
            onChange={(product, payMethod) => {
              setProduct(product);
              setPayMethod(payMethod);
            }}
          />

          <ul>
            <li>
              <input type="checkbox" id="check1"
                checked={agreeArray[0]}
                onChange={e => setAgreeArray(agreeArray.map((v, i) => {
                  if(i === 0) v = e.target.checked
                  return v
                }))}
              />
              <label htmlFor="check1">
                <span className="checkmark" />
                <p>이용자가 <strong className="green">정기자문료를 3회 이상</strong> 납부해야(=가입일로부터 2개월이 지나서야) 법률자문 서비스를 제공합니다. 단, 이용자가 특별자문료를 납부한 경우에는 그러하지 아니합니다.</p>
              </label>
            </li>
            <li>
              <input type="checkbox" id="check2"
                checked={agreeArray[1]}
                onChange={e => setAgreeArray(agreeArray.map((v, i) => {
                  if(i === 1) v = e.target.checked
                  return v
                }))}
              />
              <label htmlFor="check2">
                <span className="checkmark" />
                <p>법률자문 서비스의 범위는 해외구매대행, 국내리셀 관련 저작권법, 상표법, 부정경쟁방지법, 디자인보호법, 특허법 등 <strong className="green">지적재산권법에 한정</strong>됩니다.</p>
              </label>
            </li>
            <li>
              <input type="checkbox" id="check3"
                checked={agreeArray[2]}
                onChange={e => setAgreeArray(agreeArray.map((v, i) => {
                  if(i === 2) v = e.target.checked
                  return v
                }))}
              />
              <label htmlFor="check3">
                <span className="checkmark" />
                <p>회사는 법률자문 서비스를 제공할 뿐, 개별 사건에서 <strong className="green">이용자의 소송대리인, 변호인으로 선임되는 것이 아닙니다.</strong></p>
              </label>
            </li>
            <li>
              <input type="checkbox" id="check4" 
                checked={agreeArray[3]}
                onChange={e => setAgreeArray(agreeArray.map((v, i) => {
                  if(i === 3) v = e.target.checked
                  return v
                }))}
              />
              <label htmlFor="check4">
                <span className="checkmark" />
                <p>이용자는 회사가 지적재산권 침해신고에 대한 공동대응을 위한 목적으로 <strong className="green">제3자에게 이용자의 서비스 이용 사례를 제공함</strong>에 동의합니다.</p>
              </label>
            </li>
          </ul>

          <button className="contained_main btn_signup"
            onClick={signUp}
            disabled={agreeArray.includes(false)}
          >
            <strong className="fs16">가입하기</strong>
          </button>
        </section>
      </div>
    </Container>
  )
}